module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "longform"
  }, [_c('div', {
    staticClass: "longform-container"
  }, [_c('h1', {
    staticClass: "longform-header"
  }, [_vm._v("\r\n      Editor\r\n    ")]), _vm._v(" "), _c('textarea', {
    ref: "edit",
    staticClass: "longform-edit",
    attrs: {
      "placeholder": _vm.placeholder
    },
    on: {
      "input": function($event) {
        _vm.update($event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.value))])]), _vm._v(" "), _c('div', {
    staticClass: "longform-container longform-container--preview"
  }, [_c('h1', {
    staticClass: "longform-header"
  }, [_vm._v("\r\n      Preview\r\n    ")]), _vm._v(" "), _c('div', {
    ref: "preview",
    staticClass: "longform-preview markdown-text",
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-8ca0111e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/longformeditor.vue
// module id = 74
// module chunks = 0